module.exports = __webpack_public_path__ + "img/daat_bg.dc13dfdf.png";